import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ConfigService } from '@karve.it/core';
import { cloneDeep } from 'lodash';
import { ValidationItem } from 'src/app/app.component';
import { FreyaNotificationsService } from 'src/app/services/freya-notifications.service';
import { SubSink } from 'subsink';

export interface EstimateItem {
  name: string;
  crewSize: number;
  hours: number;

  // Subject to Change.
}

export interface EstimateItemValidation {
  name: ValidationItem;
  crewSize: ValidationItem;
  hours: ValidationItem;
}

@Component({
  selector: 'app-estimating-items',
  templateUrl: './estimating-items.component.html',
  styleUrls: ['./estimating-items.component.scss']
})
export class EstimatingItemsComponent implements OnInit, OnDestroy {

  @Input() cardView = false;

  subs = new SubSink();

  estimateItems: EstimateItem[] = [];


  deafultItem: EstimateItem = {name: '', crewSize: undefined, hours: undefined};
  itemToCreate: EstimateItem = cloneDeep(this.deafultItem);

  deafultValidation: EstimateItemValidation = {
    name: {
      message: 'Name is Required',
      touched: false,
      valid: false,
    },
    crewSize: {
      message: 'Must be greater than zero',
      touched: false,
      valid: false,
    },
    hours: {
      message: 'Must be greater than zero',
      touched: false,
      valid: false,
    }
  };

  validation: EstimateItemValidation = cloneDeep(this.deafultValidation);

  showDialog = false;

  constructor(private configService: ConfigService,
    private localNotify: FreyaNotificationsService) { }

  ngOnInit(): void {
    this.subs.sink = this.configService.getConfigValues({keys: ['estimate-items']}).subscribe((res) => {
      if (res.data.getConfigValues.length > 0) {
        this.estimateItems = JSON.parse(res.data.getConfigValues[0].value);
      }
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  openEstimateDialog(){
    this.itemToCreate = cloneDeep(this.deafultItem);
    this.validation = cloneDeep(this.deafultValidation);
    this.showDialog = true;
  }

  addEstimateItem(){
    this.showDialog = false;
    const configValue = JSON.stringify([...this.estimateItems, this.itemToCreate]);

    this.subs.sink = this.configService.setConfigValues({configs: [{key: 'estimate-items', value: configValue}]}).subscribe((_res) => {
      this.estimateItems.push(this.itemToCreate);
      this.localNotify.addToast.next({severity: 'success', summary: ''});
    });
  }

  removeEstimateItems(name: string){
    const index = this.estimateItems.findIndex((r) => r.name === name);
    this.estimateItems.splice(index, 1);

    this.subs.sink = this.configService.setConfigValues(
      {
        configs: [{key: 'estimate-items', value: JSON.stringify(this.estimateItems)}]
      }
    ).subscribe((_res) => {
      this.localNotify.addToast.next({severity: 'success', summary: ''});
    });
  }

  validate(field: string) {

    switch(field){
      case 'name':
        this.validation.name.valid = this.itemToCreate.name.length >= 1;
        break;
      case 'crewSize':
        this.validation.crewSize.valid = this.itemToCreate.crewSize > 0;
        break;
      case 'hours':
        this.validation.hours.valid = this.itemToCreate.hours > 0;
        break;

    }
  }

  focusOut(field: string) {
    this.validation[field].touched = true;
  }

}
